"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NavbarVerticalStyle1Module {
}
exports.NavbarVerticalStyle1Module = NavbarVerticalStyle1Module;
